import {
  OWNER_DETAILS_FAIL,
  OWNER_DETAILS_REQUEST,
  OWNER_DETAILS_SUCCESS
} from '../constants/ownerConstants'

export const ownerDetailsReducer = (state = { owner: {} }, action) => {
  switch (action.type) {
    case OWNER_DETAILS_REQUEST:
      return { ...state, loading: true }
    case OWNER_DETAILS_SUCCESS:
      return { loading: false, owner: action.payload }
    case OWNER_DETAILS_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}
